import { IToken } from 'shared/models/Digitain'

export class DigitainConverter {
  convertToken(data: IToken): string {
    return data.token
  }
}
